(() => {
    'use strict';

    /* ------------------------------------------------------------------
     * Hovering the logo re-writes the full signature over it.
     * ---------------------------------------------------------------- */
    const brandInit = () => {
        const brand = document.querySelector('[data-sig-brand]');
        const sig = brand && brand.querySelector('.brand-sig .sig');
        if (!brand || !sig) {
            return;
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        let playing = false;

        brand.addEventListener('mouseenter', () => {
            if (playing) {
                return;
            }
            playing = true;
            brand.classList.add('is-signing');

            // Drop and re-add the class to rewind the stroke animations; without the
            // reflow in between, the browser coalesces both changes and nothing replays.
            sig.classList.remove('sig--writing');
            void sig.offsetWidth;
            sig.classList.add('sig--writing');

            setTimeout(() => {
                brand.classList.remove('is-signing');
                playing = false;
            }, 3200);
        });
    };

    /* ------------------------------------------------------------------
     * The hamburger has to say whether the panel is open. Bootstrap keeps
     * aria-expanded in step for collapse, but not for offcanvas, so the
     * button would read "collapsed" forever on its own.
     *
     * Bound to document rather than to the button: the masthead is one of
     * swup's containers and is replaced on every navigation, so a listener
     * on the button itself would not survive one. Bootstrap's events bubble,
     * so one pair of listeners covers every panel, now and later.
     * ---------------------------------------------------------------- */
    const offcanvasStateInit = () => {
        const sync = (open) => (event) => {
            const panel = event.target;

            if (!panel || !panel.id) {
                return;
            }

            // Only the control that opens it. The close button inside the panel
            // carries the same data-bs-target and must not claim to expand anything.
            document
                .querySelectorAll('[data-bs-toggle="offcanvas"][data-bs-target="#' + panel.id + '"]')
                .forEach((toggle) => toggle.setAttribute('aria-expanded', open ? 'true' : 'false'));
        };

        document.addEventListener('show.bs.offcanvas', sync(true));
        document.addEventListener('hidden.bs.offcanvas', sync(false));
    };

    const ready = () => {
        brandInit();
        offcanvasStateInit();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ready, { once: true });
    } else {
        ready();
    }
})();
